import { Injectable } from '@angular/core';
import { BaseApi } from './_base-api';
import { WalletTransactionEntity, WalletTransactionCreate } from '@models';
import { DataGetRequest } from '@controladad/ng-base';

@Injectable({
  providedIn: 'root',
})
export class WalletTransactionApiService extends BaseApi<WalletTransactionEntity> {
  constructor() {
    super('/AdminPanel/WalletTransaction', {
      get: '/AdminPanel/GetWalletTransactionList',
    });
  }

  exportToExcel(options?: DataGetRequest) {
    return this.exportAndDownload('/AdminPanel/ExportWalletTransactionList', options, 'transactions.xlsx');
  }

  createAdminTransaction(data: WalletTransactionCreate) {
    return http$.post('/AdminPanel/AdminWalletTransaction', data);
  }
}
